module.exports = __webpack_public_path__ + "img/small.c3146de9.jpg";